module.exports = __webpack_public_path__ + "img/close-m.1119bf28.svg";